import axios, { AxiosError, AxiosResponse } from "axios";
import { AuthBodyType } from "./types";
import { applyFirebaseTokenRetry } from './api';

export default class Modelos {
  private api = applyFirebaseTokenRetry(axios.create({
    baseURL: `${process.env.REACT_APP_AXYMA_MICROSSERVICES_APIS_URL}/modelos`,
  }));

  getPreenchimentoWebV2 = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await this.api.get("/getPreenchimentoWebV2",
        { headers: { ...body } }
      );
      if (!data.data) {
        throw new Error("No data received from the API");
      }
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(`API request failed with status ${error.response?.status}`);
      }
    }
  };
}
